angular.module("acl.visualizer.mapChart.dataConfig", [
  "acl.common.localize",
  "acl.visualizer.dataModel",
  "acl.visualizer.multiSelect",
  "templates-visualizer",
]);
